import { FiltersList, FilterTypes } from '@portal/shared/ui/filter';

export const MmfiltersList: FiltersList[] = [
  {
    selector: 'appName',
    title: 'Application Name',
    type: FilterTypes.MultipleSearch,
    data: [
      {
        text: 'Application Name',
        id: 'appName',
      },
    ],
  },
  {
    selector: 'categories.name',
    title: 'Categories',
    type: FilterTypes.Multi,
    data: [
      { text: 'Advertising and media', id: 'ADVERTISING_AND_MEDIA' },
      { text: 'Alternate payments', id: 'ALTERNATE_PAYMENTS' },
      { text: 'Charity', id: 'CHARITY' },
      { text: 'Customer engagement', id: 'CUSTOMER_ENGAGEMENT' },
      {
        text: 'Customer relationship management',
        id: 'CUSTOMER_RELATIONSHIP_MANAGEMENT',
      },
      { text: 'Employee management', id: 'EMPLOYEE_MANAGEMENT' },
      { text: 'Finance', id: 'FINANCE' },
      { text: 'Inventory management', id: 'INVENTORY_MANAGEMENT' },
      { text: 'Loyalty and promotion', id: 'LOYALTY_AND_PROMOTION' },
      { text: 'Order management', id: 'ORDER_MANAGEMENT' },
      { text: 'Reporting and analytics', id: 'REPORTING_AND_ANALYTICS' },
    ],
  },
  {
    selector: 'paymentModel',
    title: 'Payment Model',
    type: FilterTypes.Multi,
    data: [
      { text: 'Free', id: 'FREE' },
      { text: 'One time', id: 'ONE_TIME' },
      { text: 'Recurring', id: 'RECURRING' },
    ],
  },
  {
    selector: 'modelFamilies.name',
    title: 'Model Family',
    type: FilterTypes.Multi,
    data: [{ text: 'Carbon Mobile', id: 'CarbonMobile' }],
  },
  {
    selector: 'deviceFamilies.name',
    title: 'Device Model',
    type: FilterTypes.Single,
    data: [
      { text: 'P630', id: 'P630' },
      { text: 'CM5', id: 'CM5' },
      { text: 'CM5P', id: 'CM5P' },
      { text: 'V660P', id: 'V660P' },
      { text: 'VM100' , id: 'VM100'},
      { text: 'VP100', id: 'VP100' },
      { text: 'VP110', id: 'VP110' },
    ],
  },
  {
    selector: 'status',
    title: 'Status',
    type: FilterTypes.Multi,
    data: [
      {
        text: 'Registered',
        id: 'REGISTERED',
      },
      { text: 'Submitted', id: 'SUBMITTED' },
      { text: 'In Review', id: 'IN_REVIEW' },
      { text: 'Approved', id: 'APPROVED' },
      { text: 'Disabled', id: 'DISABLED' },
      { text: 'Withdrawn', id: 'WITHDRAWN' },
      { text: 'Rejected', id: 'REJECTED' },
    ],
  },
];
